module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "box center-width flex-box"
  }, [_c('section', {
    staticClass: "section"
  }, [_c('a', {
    staticClass: "title",
    attrs: {
      "href": "about.html#/companyIntroduction",
      "target": "_blank"
    }
  }, [_vm._v("关于我们")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "about.html#/companyIntroduction",
      "target": "_blank"
    }
  }, [_vm._v("公司简介")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "about.html#/honor",
      "target": "_blank"
    }
  }, [_vm._v("资质荣誉")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "about.html#/news",
      "target": "_blank"
    }
  }, [_vm._v("新闻动态")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "about.html#/joinUs",
      "target": "_blank"
    }
  }, [_vm._v("加入我们")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "about.html#/contactUs",
      "target": "_blank"
    }
  }, [_vm._v("联系我们")])]), _vm._v(" "), _c('section', {
    staticClass: "section"
  }, [_c('a', {
    staticClass: "title",
    attrs: {
      "href": "webTerms.html?type=1",
      "target": "_blank"
    }
  }, [_vm._v("网站条款")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "webTerms.html?type=1",
      "target": "_blank"
    }
  }, [_vm._v("免责声明")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "webTerms.html?type=2",
      "target": "_blank"
    }
  }, [_vm._v("隐私政策")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "webTerms.html?type=3",
      "target": "_blank"
    }
  }, [_vm._v("服务条款")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "webTerms.html?type=4",
      "target": "_blank"
    }
  }, [_vm._v("平台注册协议")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "webTerms.html?type=5",
      "target": "_blank"
    }
  }, [_vm._v("平台服务协议")])]), _vm._v(" "), _c('section', {
    staticClass: "section"
  }, [_c('a', {
    staticClass: "title",
    attrs: {
      "href": "help.html?type=1",
      "target": "_blank"
    }
  }, [_vm._v("帮助中心")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "help.html?type=1",
      "target": "_blank"
    }
  }, [_vm._v("意见反馈")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "help.html?type=2",
      "target": "_blank"
    }
  }, [_vm._v("银行账号")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "help.html?type=3",
      "target": "_blank"
    }
  }, [_vm._v("交收仓库")])]), _vm._v(" "), _c('section', {
    staticClass: "section"
  }, [_c('a', {
    staticClass: "title",
    attrs: {
      "href": "about.html?type=5",
      "target": "_blank"
    }
  }, [_vm._v("联系我们")]), _vm._v(" "), _c('p', [_vm._v("总台服务:0771-2266888")]), _vm._v(" "), _c('p', [_vm._v("仓库客服:0778-2482555")]), _vm._v(" "), _c('p', [_vm._v("服务时间:周一至周五(8:30-17:30)")]), _vm._v(" "), _c('p', {
    staticClass: "mt20"
  }, [_vm._v("南宁客服中心:0771-2266888")]), _vm._v(" "), _c('p', [_vm._v("宜州办事处:0778-2482555")]), _vm._v(" "), _c('p', [_vm._v("桐乡办事处:18505735660(陆敏丰)")]), _vm._v(" "), _c('p', [_vm._v("南充办事处:15078075776(罗中政)")])]), _vm._v(" "), _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "foot-code"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/common/WeChat.jpg")
    }
  }), _vm._v(" "), _c('p', [_vm._v("茧丝微信订阅号")])]), _vm._v(" "), _c('div', {
    staticClass: "foot-code right"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/common/App.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v("丝路通APP下载")])]), _vm._v(" "), _c('p', [_vm._v("丝路通APP正式上线，实时交易、融资服务、多品交付、信息获取。茧丝绸行业交易与融资业务新工具，扫一扫下载安装，办理业务快一步。")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-22d3f369","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/common/footer.vue
// module id = 594
// module chunks = 1 5